import { fetchImageBlob } from '@/services/image-blob';

export const ACCENT = '#C87A5E';
export const TEXT = '#333333';
export const MUTED = '#666666';
export const TABLE_HEADER_BG = '#F0F0F0';
export const SURFACE = '#F9F7F5';
export const PAGE_RULE = '#E8E4E0';

export const CANVAS_WIDTH = 1240;
export const CANVAS_HEIGHT = 1754;
export const PAGE_PADDING_X = 88;
export const PAGE_PADDING_Y = 80;
export const MAIN_THUMB_HEIGHT = 248;
export const EVENT_ROW_GAP = 40;
export const PROMPT_BLOCK_TAIL_GAP = 36;
export const SUMMARY_INNER_PAD = 36;
export const SUMMARY_COL_GAP = 28;
export const SUMMARY_ROW_GAP = 20;
export const LEFT_COL_RATIO = 0.62;
export const EVENT_TABLE_GAP = 28;
export const EVENT_DATA_TABLE_HEADER_HEIGHT = 40;
export const EVENT_DATA_TABLE_BODY_TOP_GAP = 14;
export const EVENT_DATA_TABLE_BODY_BOTTOM_PAD = 12;
export const EVENT_DATA_TABLE_SOURCE_TYPE_GAP = 6;
export const EVENT_SECONDARY_THUMBS_TOP_GAP = 12;
export const EVENT_SECONDARY_THUMBS_GAP = 14;
export const EVENT_SECONDARY_THUMBS_BOTTOM_PAD = 14;
export const EVENT_SECONDARY_THUMB_MAX_WIDTH = 264;
export const EVENT_SECONDARY_THUMB_ASPECT_W = 16;
export const EVENT_SECONDARY_THUMB_ASPECT_H = 9;
export const EVENT_SECONDARY_THUMBS_HORIZONTAL_PAD = 16;
export const EVENT_SECONDARY_THUMB_CELL_INSET = 4;

export const REPORT_EXPORT_EXTRA_THUMBNAIL_FRAMES = 3;

export const layoutReportExportSecondaryThumbnailsRow = (
    panelWidth: number,
    thumbCount: number,
): {
    cellWidth: number;
    cellHeight: number;
    gap: number;
    horizontalPadding: number;
    contentWidth: number;
} => {
    if (thumbCount <= 0) {
        return {
            cellWidth: 0,
            cellHeight: 0,
            gap: EVENT_SECONDARY_THUMBS_GAP,
            horizontalPadding: EVENT_SECONDARY_THUMBS_HORIZONTAL_PAD,
            contentWidth: 0,
        };
    }
    const gap = EVENT_SECONDARY_THUMBS_GAP;
    const horizontalPadding = EVENT_SECONDARY_THUMBS_HORIZONTAL_PAD;
    const inner = Math.max(0, panelWidth - horizontalPadding * 2);
    const totalGap = gap * (thumbCount - 1);
    const rawWidth = (inner - totalGap) / thumbCount;
    let cellWidth = Math.floor(
        Math.min(EVENT_SECONDARY_THUMB_MAX_WIDTH, Math.max(52, rawWidth)),
    );
    let contentWidth = thumbCount * cellWidth + totalGap;
    while (contentWidth > inner && cellWidth > 40) {
        cellWidth -= 1;
        contentWidth = thumbCount * cellWidth + totalGap;
    }
    const cellHeight = Math.max(
        30,
        Math.round(
            (cellWidth * EVENT_SECONDARY_THUMB_ASPECT_H) /
                EVENT_SECONDARY_THUMB_ASPECT_W,
        ),
    );
    return { cellWidth, cellHeight, gap, horizontalPadding, contentWidth };
};

export const fetchImageBytes = async (
    url: string | null | undefined,
): Promise<Uint8Array | null> => {
    if (!url) {
        return null;
    }
    try {
        const blob = await fetchImageBlob(url);
        return new Uint8Array(await blob.arrayBuffer());
    } catch {
        return null;
    }
};

export const buildFrameThumbnailUrl = (
    baseThumbnailUrl: string,
    frameId: number,
): string => {
    const url = new URL(baseThumbnailUrl);
    url.searchParams.set('frame_id', frameId.toString());
    return url.toString();
};
